var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UMOTIF_API } from '@/routes';
import api from './instance';
const { NMIBLE } = UMOTIF_API;
class NmibleService {
    getStatus(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.get(NMIBLE.GET_STATUS, { params });
            return data;
        });
    }
    getPaymentMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.get(NMIBLE.GET_PAYMENT_METHODS);
            return data;
        });
    }
    setPaymentMethod(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.post(NMIBLE.SET_PAYMENT_METHOD, payload);
            return data;
        });
    }
    showVirtualCard() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.get(NMIBLE.SHOW_VIRTUAL_CARD, {
                responseType: 'text'
            });
            return data;
        });
    }
    updateUserStatus(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.post(NMIBLE.UPDATE_USER_STATUS, payload);
            return data;
        });
    }
}
export default new NmibleService();
